const config = {
    featureServices: [
      { name: "Island Names", url: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/Al_Daleela_Features/FeatureServer/91" },
      { name: "Marine Names", url: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/Al_Daleela_Features/FeatureServer/119" },
      { name: "Terrestrial Names", url: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/Al_Daleela_Features/FeatureServer/93" },
    ],    
    Print: {
      printServiceUrl: "https://devedp.ead.ae/server/rest/services/AlDaleela/AlDaleela_PrintTemplate/GPServer/Export%20Web%20Map",
    allowedFormats: ["Portable Document Format (PDF)","32-bit Portable Network Graphics (PNG32)", "Joint Photographic Experts Group (JPG)"],
    allowedLayouts: ["Print"]
    },
    Export: {
      printServiceUrlAr: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/ExportWebMap_Arabic/GPServer/Export%20Web%20Map",
      printServiceUrlEng: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/ExportWebMap_English/GPServer/Export%20Web%20Map",
      allowedFormats: ["32-bit Portable Network Graphics (PNG32)", "Joint Photographic Experts Group (JPG)"],
      allowedLayouts: ["Map"]
    },
    // layerListServices: [
    //   { name: "Island", url: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/Al_Daleela_Features/FeatureServer/91", visible:true },
    //   { name: "Marine", url: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/Al_Daleela_Features/FeatureServer/119", visible:true },
    //   { name: "Terrestrial", url: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/Al_Daleela_Features/FeatureServer/93", visible:true },
    //   { name: "Protected", url: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/layer2/FeatureServer/90", visible:false },
    //   { name: "Pearl", url: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/layer2/FeatureServer/89", visible:false },
    // ],
    layerListServices: {
      english: [
        {
          parent: {name:"Scale based Labelling",url: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/95", visible: true},
          children: [
            { name: "Island Names", id:"Island Names", url: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/91", visible: true },
            { name: "Marine Names", id:"Marine Names",url: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/119", visible: true },
            { name: "Terrestrial Names", id:"Terrestrial Names",url: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/93", visible: true },
            { name: "Protected Areas", id:"Protected Areas",url: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/90", visible: false },
            { name: "Pearl Sites", id:"Pearl Sites",url: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/89", visible: false }
          ]
        },
        {
          parent: {name:"Cluster",url: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/108", visible: false},
          children: [
            { name: "Island Names", id:"Island Names", url: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/111", visible: true },
            { name: "Marine Names", id:"Marine Names", url: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/110", visible: true },
            { name: "Terrestrial Names", id:"Terrestrial Names", url: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/109", visible: true },
            { name: "Protected Areas", id:"Protected Areas", url: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/116", visible: false },
            { name: "Pearl Sites", id:"Pearl Sites", url: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/115", visible: false }
          ]
        }
      ],
      arabic: [
        {
          parent: {name:"التسمية حسب المقياس",url: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/103", visible: true},
          children: [
            { name: "مسميات الجزر",id:"Island Names", url: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/102", visible: true },
            { name: "المسميات البحرية",id:"Marine Names", url: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/101", visible: true },
            { name: "المسميات البرية",id:"Terrestrial Names", url: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/100", visible: true },
            { name: "المحميات الطبيعية", id:"Protected Areas",url: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/96", visible: false },
            { name: "مغاصات اللولو", id:"Pearl Sites",url: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/97", visible: false }
          ]
        },
        {
          parent: {name:"التكتل",url: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/104", visible: false},
          children: [
            { name: "مسميات الجزر",id:"Island Names", url: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/2", visible: true },
            { name: "المسميات البحرية",id:"Marine Names", url: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/105", visible: true },
            { name: "المسميات البرية",id:"Terrestrial Names", url: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/3", visible: true },
            { name: "المحميات الطبيعية",id:"Protected Areas", url: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/107", visible: false },
            { name: "مغاصات اللولو",id:"Pearl Sites", url: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer/106", visible: false }
          ]
        }
      ]
    },
    //   // Arabic Layers
    //   { 
    //     name: "Island_Arabic", 
    //     url: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/Al_Daleela_Features/FeatureServer/91", 
    //     visible: true 
    //   },
    //   { 
    //     name: "Marine_Arabic", 
    //     url: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/Al_Daleela_Features/FeatureServer/119", 
    //     visible: true 
    //   },
    //   { 
    //     name: "Terrestrial_Arabic", 
    //     url: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/Al_Daleela_Features/FeatureServer/93", 
    //     visible: true 
    //   },
    //   { 
    //     name: "Protected_Arabic", 
    //     url: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/layer2/FeatureServer/90", 
    //     visible: false 
    //   },
    //   { 
    //     name: "Pearl_Arabic", 
    //     url: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/layer2/FeatureServer/89", 
    //     visible: false 
    //   },
  
    //   // English Layers
    //   { 
    //     name: "Island_English", 
    //     url: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/Al_Daleela_Features/FeatureServer/91", 
    //     visible: false 
    //   },
    //   { 
    //     name: "Marine_English", 
    //     url: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/Al_Daleela_Features/FeatureServer/119", 
    //     visible: false 
    //   },
    //   { 
    //     name: "Terrestrial_English", 
    //     url: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/Al_Daleela_Features/FeatureServer/93", 
    //     visible: false 
    //   },
    //   { 
    //     name: "Protected_English", 
    //     url: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/layer2/FeatureServer/90", 
    //     visible: false 
    //   },
    //   { 
    //     name: "Pearl_English", 
    //     url: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/layer2/FeatureServer/89", 
    //     visible: false 
    //   }
    // ],
    basemapsConfig: {
      Arabic: [
        {
          title: "خريطة أساس رمادية داكنة بالعربية - الإحداثيات الجغرافية",
          id: " Dark  Geographic",
          thumbnailImg: "./images/Basemap Arabic Dark Gray Geographic coordinates.png",
          baseLayers: [
            "https://arcgis.sdi.abudhabi.ae/agshost/rest/services/Hosted/BaseMapAra_DarkGray_GCS/MapServer"
          ]
        },
        // {
        //   title: "خريطة أساس رمادية داكنة بالعربية - إحداثيات ويب ميركاتور",
        //   id: "Basemap Arabic Dark Gray Web Mercator coordinates",
        //   thumbnailImg: "./images/Arabic Dark Gray Web Mercator .png",
        //   baseLayers: [
        //     "https://arcgis.sdi.abudhabi.ae/agshost/rest/services/Hosted/BaseMapAra_DarkGray_WM/MapServer"
        //   ]
        // },
        {
          title: "خريطة أساس رمادية فاتحة بالعربية - الإحداثيات الجغرافية",
          id: " Light  Geographic",
          thumbnailImg: "./images/Arabic light Gray Geographic.jpg",
          baseLayers: [
            "https://arcgis.sdi.abudhabi.ae/agshost/rest/services/Hosted/BaseMapAra_LightGray_GCS/MapServer"
          ]
        },
        // {
        //   title: "خريطة أساس رمادية فاتحة بالعربية - إحداثيات ويب ميركاتور",
        //   id: "Basemap Arabic Light Gray Web Mercator coordinates",
        //   thumbnailImg: "./images/Arabic light Gray Web Mercator.png",
        //   baseLayers: [
        //     "https://arcgis.sdi.abudhabi.ae/agshost/rest/services/Hosted/BaseMapAra_LightGray_WM/MapServer"
        //   ]
        // },
        {
          title: "صور الأقمار الصناعية",
          id: "Satellite imagery Arabic",
          thumbnailImg: "./images/ESRI Satellite Imagery.png",
          baseLayers: [
            "https://arcgis.sdi.abudhabi.ae/arcgis/rest/services/Pub/IMG_SAT_50CM_WM/MapServer"
          ]
        },
        {
          title: " صور الأقمار إزري ",
          id: "Satellite imagery English",
          thumbnailImg: "./images/ESRI World Imagery.png",
          baseLayers: [
            "https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer"
          ]
        },
              {
        title: "خريطة طوبوغرافية",
        id: "Topographic Map Arabic",
        thumbnailImg: "./images/topo_Ar.png",
        baseLayers: [
          "https://services.arcgisonline.com/arcgis/rest/services/World_Topo_Map/MapServer"
        ]
      }
      ],
      English: [
        {
          title: "Dark Geographic",
          id: "Basemap English Dark Gray Geographic coordinates",
          thumbnailImg: "./images/English Dark Gray Geographic.png",
          baseLayers: [
            "https://arcgis.sdi.abudhabi.ae/agshost/rest/services/Hosted/BaseMapEng_DarkGray_GCS/MapServer"
          ]
        },
        // {
        //   title: "English Dark Gray Web Mercator",
        //   id: "Basemap English Dark Gray Web Mercator coordinates",
        //   thumbnailImg: "./images/English Dark Gray Web Mercator.png",
        //   baseLayers: [
        //     "https://arcgis.sdi.abudhabi.ae/agshost/rest/services/Hosted/BaseMapEng_DarkGray_WM/MapServer"
        //   ]
        // },
        {
          title: "Light  Geographic",
          id: "Basemap English Light Gray Geographic coordinates",
          thumbnailImg: "./images/English light Gray Geographic.png",
          baseLayers: [
            "https://arcgis.sdi.abudhabi.ae/agshost/rest/services/Hosted/BaseMapEng_LightGray_GCS/MapServer"
          ]
        },
        // {
        //   title: "English Light Gray Web Mercator",
        //   id: "Basemap English Light Gray Web Mercator coordinates",
        //   thumbnailImg: "./images/English Light Gray Web Mercator.png",
        //   baseLayers: [
        //     "https://arcgis.sdi.abudhabi.ae/agshost/rest/services/Hosted/BaseMapEng_LightGray_WM/MapServer"
        //   ]
        // },
        {
          title: "Satellite Imagery",
          id: "Satellite imagery English",
          thumbnailImg: "./images/ESRI Satellite Imagery.png",
          baseLayers: [
            "https://arcgis.sdi.abudhabi.ae/arcgis/rest/services/Pub/IMG_SAT_50CM_WM/MapServer"
          ]
        },
        {
          title: "ESRI Satellite Imagery",
          id: "Satellite imagery English",
          thumbnailImg: "./images/ESRI World Imagery.png",
          baseLayers: [
            "https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer"
          ]
        },
              {
        title: "Topographic Map",
        id: "Topographic Map English",
        thumbnailImg: "./images/Topo_Eng.png",
        baseLayers: [
          "https://services.arcgisonline.com/arcgis/rest/services/World_Topo_Map/MapServer"
        ]
      }
      ]
    },
    PortalUrl: "https://maps.smartgeoapps.com/portal",
    ItemWebMapID: "ac2003df385e4c1ead7d2243e3909c26",
    ItemWebMapIDEng: "6fddac3ec20e44f2874532b3fad771e0",
    BaseUrl: "https://maps.smartgeoapps.com/server/rest/services/AlDaleela/Al_Daleela_Features/MapServer"
  };
  
  export default config;
  